import 'abortcontroller-polyfill/dist/polyfill-patch-fetch';
import { lightThemeVars } from '@tgtg/kit';
import { captureOpenedCharityId } from 'common/storage/openedCharityStorage';
import { createRoot } from 'react-dom/client';

import App from './core/App';
import { sentryCapture } from './sentry/sentryCapture';

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root element not found');
}
const root = createRoot(container, {
  onRecoverableError: (err) => {
    const error = err as Error;
    sentryCapture('Recoverable Error', 'recoverable', error);
  },
  onUncaughtError: (err) => {
    const error = err as Error;
    sentryCapture('Uncaught Error', 'uncaught', error);
  },
  onCaughtError: (err, errInfo) => {
    const error = err as Error;
    sentryCapture('Caught Error', 'caughtError', error, errInfo?.componentStack ?? undefined);
  },
});

captureOpenedCharityId();
document.body.classList.add(lightThemeVars);
root.render(<App />);
